
import { Icon } from '@chakra-ui/react';
export const RightPoint = (props) => (
  <Icon viewBox="0 0 20 20" boxSize="16px" color="icon.g1" {...props}>
<path d="M9.46811 13.0581L11.818 10.6534C12.1718 10.2913 12.1718 9.70641 11.818 9.34431L9.46811 6.93965C8.89653 6.35473 7.91667 6.77253 7.91667 7.59884L7.91667 12.4082C7.91667 13.2345 8.89653 13.643 9.46811 13.0581Z" fill="currentColor"/>
</Icon>
  );
